import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

// Generate a random share token
export const generateShareToken = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';
  for (let i = 0; i < 12; i++) {
    token += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return token;
};

export const createShareLink = async (type: 'item' | 'board', targetId: string) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      toast.error("You must be logged in to share");
      return null;
    }
    
    // Get user's display name from auth user email
    const displayName = user.email?.split('@')[0] || user.user_metadata?.name || 'Someone';
    
    // Check if share already exists
    const query = supabase.from('shares').select('share_token');
    if (type === 'item') {
      query.eq('item_id', targetId);
    } else {
      query.eq('board_id', targetId);
    }
    
    const { data: existing } = await query.maybeSingle();
    
    if (existing) {
      // Return existing share link
      return `${window.location.origin}/share/${existing.share_token}`;
    }
    
    // Create new share
    const shareToken = generateShareToken();
    
    const shareData = {
      share_type: type,
      item_id: type === 'item' ? targetId : null,
      board_id: type === 'board' ? targetId : null,
      shared_by: user.id,
      shared_by_name: displayName,
      share_token: shareToken,
      allow_guest_view: true,
      require_account: false
    };
    
    const { error } = await supabase.from('shares').insert(shareData);
    
    if (error) {
      console.error('Failed to create share:', error);
      toast.error('Failed to create share link');
      return null;
    }
    
    return `${window.location.origin}/share/${shareToken}`;
  } catch (error) {
    console.error('Share link creation error:', error);
    toast.error('An unexpected error occurred');
    return null;
  }
};

// Copy link to clipboard
export const copyShareLink = async (type: 'item' | 'board', targetId: string) => {
  const link = await createShareLink(type, targetId);
  
  if (link) {
    await navigator.clipboard.writeText(link);
    toast.success('Share link copied to clipboard!');
    return link;
  }
  return null;
};
